import script from "./DefPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./DefPopover.vue?vue&type=script&setup=true&lang=js"

import "./DefPopover.vue?vue&type=style&index=0&id=4a877ba9&lang=css"

const __exports__ = script;

export default __exports__